import { StaffData } from '../types/staffData';
import { getUserSelectOptions } from './processAndTaskFormUtils';

// 無効化された営業(積算)担当者を含め、セレクトボックス用に展開
export const getStaffSelectOptions = (
  userData: any[],
  staffData: StaffData | null | StaffData[]
) => {
  let staffOptions: any[] = [];
  if (staffData) {
    if (Array.isArray(staffData)) {
      staffOptions = staffData.map(staff => {
        return <option value={staff.id}>{staff.name}</option>;
      });
    } else {
      staffOptions = [<option value={staffData.id}>{staffData.name}</option>];
    }
  }

  return [...getUserSelectOptions(userData), ...staffOptions];
};
